import api from './api';

// A member's own customer records for one portal section (CIN-7192). The server decides which records and which
// fields; nothing here can widen that.
const recordsService = {
  async getRecords(groupId, sectionKey) {
    try {
      const response = await api.get(`/members/group/${groupId}/records/${sectionKey}`);
      return response.data.results;
    } catch (error) {
      console.error(`Get ${sectionKey} records error:`, error);
      throw error;
    }
  },

  async getRecord(groupId, sectionKey, recordId) {
    try {
      const response = await api.get(`/members/group/${groupId}/records/${sectionKey}/${recordId}`);
      return response.data.result;
    } catch (error) {
      console.error(`Get ${sectionKey} record error:`, error);
      throw error;
    }
  },

  // A vehicle's service map: parts serviced recently, work coming due, and work the member declined.
  async getServiceMap(groupId, vehicleId) {
    try {
      const response = await api.get(`/members/group/${groupId}/records/vehicles/${vehicleId}/service-map`);
      return response.data.result;
    } catch (error) {
      console.error('Get vehicle service map error:', error);
      throw error;
    }
  },
};

export default recordsService;
